import React from "react";
import { X, MessageSquare } from "lucide-react";

export default function ProcurementNotesModal({
  isOpen,
  onClose,
  item,
  tempNotes,
  setTempNotes,
  onSubmit
}) {
  if (!isOpen || !item) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "500px" }}>
        <div className="modal-header">
          <h3>Item Notes</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div style={{ padding: "1.5rem" }}>
          <div style={{ marginBottom: "1rem" }}>
            <span className="procurement-modal-label">Item</span>
            <strong className="procurement-modal-item-name">{item.description || item.name || "Unnamed Item"}</strong>
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <span className="procurement-modal-label" style={{ marginBottom: "0.5rem" }}>Log History</span>
            <div className="procurement-log-scroll">
              {item.logs && [...item.logs].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((log, idx) => (
                <div key={idx} className="procurement-log-entry">
                  <div className="procurement-log-header">
                    <span className="procurement-log-type">{log.type}</span>
                    <span className="procurement-log-timestamp">{new Date(log.timestamp).toLocaleString()}{log.author ? ` • ${log.author}` : ""}</span>
                  </div>
                  <p className="procurement-log-text">{log.text}</p>
                </div>
              ))}
              {(!item.logs || item.logs.length === 0) && (
                <div className="procurement-empty-text">No logs recorded yet.</div>
              )}
            </div>
          </div>

          <div className="form-group" style={{ marginBottom: "1.5rem" }}>
            <label className="form-label" htmlFor="procurementItemNotes">Append New Log</label>
            <textarea
              id="procurementItemNotes"
              className="form-input"
              style={{ minHeight: "80px", padding: "0.75rem" }}
              value={tempNotes}
              onChange={(e) => setTempNotes(e.target.value)}
              placeholder="Add vendor communication, order updates, or tracking info..."
            />
          </div>

          <div className="procurement-modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={onSubmit} disabled={!tempNotes.trim()}>
              Save Log
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
